import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import Images from "../../Assets/Images/Images";
import Colors from "../../Assets/Styles/Colors";
import { SuccessToaster } from "../../Components/Toaster/Toaster";
import {
  InputField,
  OutlineInputField,
} from "../../Components/Fields/TextFields";
import { FaxRounded, Visibility, VisibilityOff } from "@mui/icons-material";
import { PrimaryButton } from "../../Components/Buttons/index";
import { useNavigate } from "react-router-dom";
import AuthServices from "../../Api/Auth/AuthServices";
import useAuth from "./../../hooks/useAuth";
import { getUserToken } from "./../../firebase/firebase";

const Login = () => {
  const navigate = useNavigate();
  const { userLogin } = useAuth();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  // *For Show Password Toggle Icon
  const [showPassword, setShowPassword] = useState(false);

  const onLogin = async (formData) => {
    setLoading(true);
    try {
      const fcmToken = await getUserToken();
      console.log("🚀 ~ onLogin ~ fcmToken:", fcmToken)
      const obj = {
        fcmToken: fcmToken,
        // phone_Number: formData.email,
        email: formData.email,
        password: formData.password,
      };
      const result = await AuthServices.login(obj);
      console.log("🚀 result", result);
      if (result.status === true && result.responseCode === 200) {
        // SuccessToaster(message);
        localStorage.setItem("token", result?.data?.user?.token);
        // localStorage.setItem("fcmToken", fcmToken);
        userLogin(result?.data?.user);
        navigate("/");
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };
  return (
    <Grid container alignItems={"center"} sx={{ height: "100vh" }}>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            p: 3,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <img src={Images.logo} width="30%" alt="logo" />
          <Box>
            {/* <img src={Images.banner} width="70%" alt="login" /> */}
          </Box>
          <Typography
            variant="h4"
            sx={{ color: Colors.black, fontWeight: "bold" }}
          >
            {" "}
            Welcome
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          sx={{
            boxShadow: "rgb(255 0 0) 0px 48px 100px 0px",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              p: 3,
              borderRadius: 2,
              width: 0.7,
              boxSizing: "border-box",
            }}
          >
            <Typography variant="h4" sx={{ color: Colors.black, my: 2 }}>
              Login
            </Typography>
            <Divider sx={{ mb: 1.5, bgcolor: Colors.primaryLight }} />
            <Box component={"form"} onSubmit={handleSubmit(onLogin)} sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
              <OutlineInputField
                label="Email"
                type="email"
                error={errors?.email?.message}
                register={register("email", {
                  required: "Please enter your email address.",
                })}
                helperText={errors?.email?.message}
              />
              <OutlineInputField
                label="Password"
                type={showPassword ? "text" : "password"}
                helperText={errors?.password?.message}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      sx={{ color: Colors.darkMintGreen, fontSize: "18px" }}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                }
                error={errors?.password?.message}
                register={register("password", {
                  required: "Please enter password.",
                })}
              />
              <PrimaryButton
                title="Login"
                type="submit"
                loading={loading ? "loading" : null}
                fullWidth={true}
              />
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Login;
